<template>
  <div :class="[
    'rest-item-list' + webVendorLayout,
    { active: activeID == item.restaurant_id },
  ]">
    <div @click="redirect()" v-if="webVendorLayout == 1" class="mouse-hover">
      <div v-if="!right" class="resturant-item mb-0 d-flex align-items-start">
        <div :class="{ Schedule: isSchedule == '1', closed: isSchedule != '1' }" v-if="item.restaurant_on_off == '0'">
          <div class="img-cls resimg-squre">
            <img :src="item.icon_image"  @error="imageErrorHandle"/>
          </div>
        </div>
        <div v-else>
          <div class="img-cls resimg-squre">
            <img :src="item.icon_image" />
          </div>
        </div>
        <div class="resturant-data pt-0 ml-3">
          <h4>{{ item.name }}</h4>
          <span>{{ item.cuisine_name.join(", ") }}</span>
          <div class="res-price-main mt-lg-2 mt-0 text-white d-flex">
            <div class="star-rate text-white" :class="parseFloat(item.rating).toFixed(1) > 2.0 ||
                parseFloat(item.rating).toFixed(1) == 0.0
                ? 'green-cls'
                : 'red-cls'
              ">
              <i class="fas fa-star text-white mr-2"></i>
              <span class="text-white" v-if="item.rating == 0">{{
                parseFloat(item.rating).toFixed(1)
                }}</span>
              <span class="text-white" v-else>{{
                parseFloat(item.rating).toFixed(1)
                }}</span>
            </div>
            <ul class="time-price d-flex justify-content-center mb-0 ml-3">
              <li v-if="isPickupDelivery == '2'">{{ item.distance }}</li>
              <li v-else>{{ item.delivery_times }} Mins</li>
              <!-- <div v-if="item.two_person_price == 0"></div> -->
              <!-- <li v-else><span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{parseFloat(item.two_person_price).toFixed(1)}} for two</li> -->
              <li>{{ parseFloat(item.distance) }} Km</li>
            </ul>
          </div>
          <div class="offer-lbl" v-if="item.discount_text">
            <p>
              <img src="@/assets/images/offer.png" />{{ item.discount_text }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div @click="redirect()" v-if="webVendorLayout == 2" class="mouse-hover">
      <div v-if="!right" class="resturant-item-layout2 d-flex align-items-start">
        <div :class="{ Schedule: isSchedule == '1', closed: isSchedule != '1' }" v-if="item.restaurant_on_off == '0'"
          class="itemimg-thumb">
          <div class="img-cls itemimg-thumb">
            <p v-if="isPickupDelivery == '2'">{{ item.distance }}</p>
            <p v-else>{{ item.delivery_time }}</p>
            <div class="offer-lbl" v-if="item.discount_text">
              <p>{{ item.discount_text }}</p>
            </div>
            <img :src="item.icon_image" />
          </div>
        </div>
        <div v-else class="itemimg-thumb">
          <div class="offer-lbl" v-if="item.discount_text">
            <p>{{ item.discount_text }}</p>
          </div>
          <div class="img-cls">
            <p v-if="isPickupDelivery == '2'">{{ item.distance }}</p>
            <p v-else>{{ item.delivery_time }}</p>
            <img :src="item.icon_image" />
          </div>
          <div class="get-flat-cashback" v-if="item?.dinein_dicount_title_message">
            <h6>{{ item.dinein_dicount_title_message }}</h6>
            <p v-if="item?.dinein_dicount_cashback_message">
              {{ item?.dinein_dicount_cashback_message }}
            </p>
          </div>
        </div>
      </div>
      <div class="resturant-data-name resdata-nw">
        <div class="reting-name-nw">
          <h4>{{ item.name }}</h4>
          <div class="star-rate" :class="parseFloat(item.rating).toFixed(1) > 2.0 ||
              parseFloat(item.rating).toFixed(1) == 0.0
              ? 'green-cls'
              : 'red-cls'
            ">
            <i class="fas fa-star mr-2"></i>
            <span v-if="item.rating == 0">{{
              parseFloat(item.rating).toFixed(1)
              }}</span>
            <span v-else>{{ parseFloat(item.rating).toFixed(1) }}</span>
          </div>
        </div>
        <div class="res-price-main mt-2 d-flex justify-content-between">
          <p class="item-name-nw">{{ item.cuisine_name.join(", ") }}</p>
          <div class="time-price d-flex justify-content-center mb-0 ml-3">
            <div v-if="item.two_person_price == 0"></div>
            <p v-else>
              <span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                parseFloat(item.two_person_price).toFixed(1) }} for two
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { imageErrorHandle } from '../helper/helper';

export default {
  data(){
    return {
      imageErrorHandle:imageErrorHandle,
    };
  },
  props: [
    "item",
    "right",
    "isPickupDelivery",
    "isSchedule",
    "webVendorLayout",
    "activeID",
  ],
  mounted() { },
  methods: {
    redirect() {
      if (this.isPickupDelivery == 2) {
        this.$router.push({
          name: "vendor",
          params: {
            delivery_type: "reservation",
            restaurant_name: this.item.slug,
          },
        });
      } else {
        const url = new URL(
          "restaurant-details/" + btoa(this.item.restaurant_id),
          window.location.origin
        );
        window.location.href = url.toString();
      }
      // alert(this.isPickupDelivery)
      // this.$route.push({name:'vendor', params:{delivery_type:(isPickupDelivery == '1'?'delivery':isPickupDelivery == '0'?'takeaway':isPickupDelivery == '2'?'reservation':''),restaurant_name: item.slug}})
      // :to="{name: (isPickupDelivery == '2' && item.restaurant_on_off == '0'?'':'vendor'), params:{delivery_type:(isPickupDelivery == '1'?'delivery':isPickupDelivery == '0'?'takeaway':isPickupDelivery == '2'?'reservation':''),restaurant_name: item.slug}}" v-if="webVendorLayout == 2"
    },
  },
};
</script>
